<script setup lang="ts">
import Footer from "@/components/Footer.vue";
import Card from "@/components/ui/card/Card.vue";
import CardContent from "@/components/ui/card/CardContent.vue";
import CardHeader from "@/components/ui/card/CardHeader.vue";
import HeaderView from "@/views/HeaderView.vue";
import LanInfoView from "@/views/LanInfoView.vue";
import NoBookings from "@/views/NoBookings.vue";
import { ref, computed } from "vue";
import { useBreakpoints, breakpointsTailwind } from "@vueuse/core";
import Navigation from "@/components/Navigation.vue";
import { useEventsStore } from "@/stores/events.js";
import { useUserDataStore } from "@/stores/userData";
import Banner from "@/components/Banner.vue";

const breakpoints = useBreakpoints(breakpointsTailwind);
const isMobile = breakpoints.smaller("lg"); // true if screen width is less than 'lg' breakpoint

const eventsStore = useEventsStore();
const userDataStore = useUserDataStore();
const userId = computed(() => userDataStore.steamId);

const eventIds = computed(() => {
  return userDataStore.events;
});

const empty = computed(() => {
  return !(userDataStore.events.length > 0);
});

// fetch all events:

const events = computed(() => {
  function filterBySignedUp(event) {
    return eventIds?.value.some((userEvent) => userEvent == event.id);
  }
  return eventsStore.events
    ?.filter(filterBySignedUp)
    .slice()
    .sort(function (a, b) {
      return a.startDate - b.startDate;
    });
});

function cancelBooking(eventId, originalSeat) {
  // Remove seat booking
  if (originalSeat == null) {
    originalSeat = [null, null];
  }
  eventsStore.updateSeatBooking(
    eventId,
    [null, null],
    userId.value,
    originalSeat
  );

  // Remove user from all interests (wait until merge of model)
  const event = eventsStore.getEventById(eventId);
  const interests = eventsStore.getInterests(event);
  eventsStore.removeUserFromBatchInterest(eventId, interests, userId.value);

  // Remove event from user
  userDataStore.removeEvent(eventId);
}
</script>

<template>
  <div v-if="!isMobile" class="w-full h-20">
    <Navigation
      :username="userDataStore.userProfile?.nickname"
      :avatarUrl="userDataStore.avatarUrl"
      :isLoggedIn="userDataStore.isLoggedIn"
    ></Navigation>
  </div>

  <Card
    class="w-full h-full rounded-0 border-0 shadow-none bg-background lg:pt-0 lg:gap-0 px-4 lg:px-16"
  >
    <CardHeader>
      <HeaderView v-if="isMobile" name="Your Events"></HeaderView>
    </CardHeader>

    <CardContent class="mt-0">
      <div v-if="empty === true">
        <NoBookings :isLoggedIn="userDataStore.isLoggedIn"></NoBookings>
      </div>

      <div v-if="empty === false">
        <div
          v-if="!isMobile"
          class="inset-0 z-10 w-full h-50 mb-4"
          style="
            background-image: url('https://images.unsplash.com/photo-1544652478-6653e09f18a2?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D');
            background-size: cover;
            background-position: center;
          "
        >
          <div
            class="flex items-center justify-center h-full text-3xl font-semibold bg-black/50 text-white"
          >
            Your bookings
          </div>
        </div>
        <LanInfoView
          :events="events"
          :uid="userId"
          :findSeat="eventsStore.getSeatBookingForUser"
          @cancelBooking="cancelBooking"
        ></LanInfoView>
      </div>
    </CardContent>
  </Card>
  <Footer v-if="isMobile"></Footer>
</template>
